import React, { useEffect, useRef, useState } from "react";
import "../brandselfauditkit/SelfBybAudit/BybAudit.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import bybaudit from "../../../assets/selfaudit/images/bybaudit.jpeg";
// import map from "../../../assets/selfaudit/images/map.svg";
// import engagement from "../../../assets/selfaudit/images/engagement.svg";
// import auditline from "../../../assets/selfaudit/images/auditline.png";

gsap.registerPlugin(ScrollTrigger);

function WhatYouLearn() {

  const [isVisible, setIsVisible] = useState(false);
  const textRef = useRef(null);
  // Intersection Observer for fade-in text
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting); // Set visibility based on intersection
      },
      {
        threshold: 0.5, // Trigger when 50% of the element is visible
      }
    );

    const textElement = textRef.current;
    if (textElement) observer.observe(textElement);

    return () => {
      if (textElement) observer.unobserve(textElement);
    };
  }, []);
  return (
    <section className="byb-audit what_youlearn">
      <div className="container">
        {/* Header with fade-in effect */}
        <div className="byb-audit-header" >
          <p
            ref={textRef}
            className={`fade-in-text ${isVisible ? "visible" : ""}`}
          >
            BREW YOUR BRAND - COMPLETE BRAND SERIES

          </p>
          <h1>What You’ll Learn (Quick Snapshot)</h1>
        </div>

        {/* Video section */}
        <div
          className="scroll-through-hero st-hero-animate sth-fadein-off byb-toolkit"
          
        >
          <div className="scroll-through-hero-pin scroll_pin desktop_show">
            <div className="video-container">
              <video
                // ref={videoRef}
                src="https://brewyourbrand.blr1.digitaloceanspaces.com/book3.webm"
                playsInline
                webkit-playsInline
                preload="auto"
                muted
                className="video-background"
                // style={{ width: "100%", height: "100%" }}
              />
            </div>
          </div>
        </div>

        {/* Mobile image placeholder */}
        <img
          src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/book3.svg"
          className="show_mob w-100"
          alt="Every Interaction"
        />

        {/* Bottom content */}
        <div className="what_makes desc_para second_row_down">
         <div className="">
              <p className="learn_desc">
           In this series, you’ll learn how to:</p>
        </div>

          <div className="byb-audit-bottom-down">
            <div className="key-para">
              <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/learning/output-onlinepngtools.png" alt="Audit Line" />
              <img src="https://brewyourbrand.in/static/media/key.1d87d5990d47b45c7fbcfc632398c77f.svg" alt="Key Icon" />
              <p>
                Build a strong brand foundation rooted in purpose and values
              </p>
              {/* <img className="map-img" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/learning/output-onlinepngtools.png" alt="Audit Line" /> */}
            </div>
            <div className="engagement-para">
              <img className="engagement-img" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/learning/output-onlinepngtools.png" alt="Audit Line" />
              <img src="https://brewyourbrand.in/static/media/engagement.fdad48e3e5dbce530167e7c348f3e137.svg " alt="Engagement Icon" />
              <p>
              Claim a clear position in your customer’s mind
              </p>
              {/* <img className="map-img" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/learning/output-onlinepngtools.png" alt="Audit Line" /> */}
            </div>
            <div className="map-para">
              <img className="map-img" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/learning/output-onlinepngtools.png" alt="Audit Line" />
              <img src="https://brewyourbrand.in/static/media/map.bec227c7e53c4c9616b4c3647586150c.svg" alt="Map Icon" />
              <p>
                Turn your brand into a relatable, human personality
              </p>
              {/* <img className="map-img" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/learning/output-onlinepngtools.png" alt="Audit Line" /> */}
            </div>
          </div>

            <div className="byb-audit-bottom-down ">
            <div className="key-para">
              <img src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/learning/output-onlinepngtools.png" alt="Audit Line" />
              <img src="https://brewyourbrand.in/static/media/key.1d87d5990d47b45c7fbcfc632398c77f.svg" alt="Key Icon" />
              <p>
                Communicate messages people remember and repeat
              </p>
              {/* <img className="map-img" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/learning/output-onlinepngtools.png" alt="Audit Line" /> */}
            </div>
            <div className="engagement-para">
              <img className="engagement-img" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/learning/output-onlinepngtools.png" alt="Audit Line" />
              <img src="https://brewyourbrand.in/static/media/engagement.fdad48e3e5dbce530167e7c348f3e137.svg " alt="Engagement Icon" />
              <p>
              Create a visual identity 
that builds recognition and trust
              </p>
              {/* <img className="map-img" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/learning/output-onlinepngtools.png" alt="Audit Line" /> */}
            </div>
            <div className="map-para">
              <img className="map-img" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/learning/output-onlinepngtools.png" alt="Audit Line" />
              <img src="https://brewyourbrand.in/static/media/map.bec227c7e53c4c9616b4c3647586150c.svg" alt="Map Icon" />
              <p>
Bring everything 
together into a complete brand system              </p>
              {/* <img className="map-img" src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/learning/output-onlinepngtools.png" alt="Audit Line" /> */}
            </div>
          </div>

        <div className="center_section">
           <div className="row  align-items-stretch ">

          <div className="col-md-6">
            <div className="gradient-card gradient-card2">
              <h2 className="watch-title">
                Each episode builds on the previous one.
              </h2>

              <h2 className="watch-title">Skipping one means weakening the whole.</h2>
               
            </div>
          </div>

          {/* Right Column: Video/Image Card */}
          <div className="col-md-6">
            <div className="video-card">
              <img 
                src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/learning/binoy_learns.jpg" 
                alt="Presenter" 
                className="img-fluid video-thumbnail"
              />
              {/* Optional: Add a play button overlay here if needed */}
            </div>
          </div>
          </div>
        </div>
        </div>
      </div>
    </section>
  );
}

export default WhatYouLearn;
